import { useMemo } from 'react';
export var useConversationEmpty = function useConversationEmpty(_ref) {
  var messagesCount = _ref.messagesCount,
      isStreaming = _ref.isStreaming,
      isLoading = _ref.isLoading,
      _ref$emptyMessage = _ref.emptyMessage,
      emptyMessage = _ref$emptyMessage === void 0 ? 'No messages yet. Start the conversation.' : _ref$emptyMessage;
  var isEmptyMessage = useMemo(function () {
    return !isLoading && messagesCount === 0 && !isStreaming;
  }, [isLoading, messagesCount, isStreaming]);
  return {
    isEmptyMessage: isEmptyMessage,
    emptyMessage: emptyMessage
  };
};